import(/* webpackMode: "eager" */ "/app/src/app/[locale]/compliance/error.tsx");
